import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface NotificationMessage {
    message: string;
    title?: string;
    url?: string;
}

@Injectable({
    providedIn: 'root',
})
export class NotificationService {
    private notificationMessagesSubject = new BehaviorSubject<
        NotificationMessage[]
    >([]);
    notificationMessages$ = this.notificationMessagesSubject.asObservable();

    addNotification({
        message,
        title,
        url,
    }: {
        message: string;
        title?: string;
        url?: string;
    }): void {
        const newNotification: NotificationMessage = { message, title, url };
        const currentMessages: NotificationMessage[] =
            this.notificationMessagesSubject.value;
        this.notificationMessagesSubject.next([
            newNotification,
            ...currentMessages,
        ]);
    }

    clearNotifications(): void {
        this.notificationMessagesSubject.next([]);
    }

    appendNotifications(messages: NotificationMessage[]): void {
        this.notificationMessagesSubject.next([
            ...this.notificationMessagesSubject.value,
            ...messages,
        ]);
    }
}
